import React from 'react';
import { message, Upload } from 'antd';
import { putObject } from '@/utils/upload';
import { UploadOutlined } from '@ant-design/icons';
import AttentionTip from '@/components/attentionTip';
/**
 *
 * @param props
 * @params mode 模式 支持单张和多张上传
 *
 * @returns {JSX.Element}
 */
export default function ImgUpload(props) {
  const {
    mode = 'single',
    imgList,
    setImgList,
    text,
    maxSize,
    maxNum = 9,
    list,
    uploadItem,
    uploadIndex,
    setSelectedGoodList,
  } = props;

  const onDelete = (file) => {
    if (list) {
      const _index = list[uploadIndex].imgList.findIndex(
        (item) => item.url === file.url,
      );

      const _list = [...list];
      _list[uploadIndex].imgList.splice(_index, 1);
      setSelectedGoodList(_list);
    } else {
      const index = imgList.findIndex((item) => item.url === file.url);
      const cache = [...imgList];
      cache.splice(index, 1);
      setImgList(cache);
    }
  };

  const customRequest = ({ file, onProgress, onError, onSuccess }) => {
    if (maxSize && file.size > maxSize) {
      message.error('图片大小不能超过2M');
      return;
    }

    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    const types = ['PNG', 'JPG', 'JPEG'];
    if (!types.includes(fileType.toUpperCase())) {
      message.error('不支持此类型文件！');
      return;
    }

    if (
      (imgList && imgList.length >= 9) ||
      (uploadItem && uploadItem.imgList.length >= 9)
    ) {
      message.error('最多支持9张图片!');
      return;
    }

    putObject({
      filename: file.name,
      file,
      onProgress,
      callback: (err, data) => {
        if (err) {
          onError(err);
        }
        if (data) {
          const da = {
            percent: 1,
            name: file.name,
            thumbUrl: `https://${data.Location}`,
            url: `https://${data.Location}`,
          };

          if (list && list.length > 0) {
            const _list = [...list];
            let _index = 0;
            for (const row of _list) {
              if (row.id == uploadItem.id) {
                break;
              }

              _index++;
            }

            _list[_index].imgList.push(da);

            setSelectedGoodList(_list);
          } else {
            setImgList((previous) => [...previous, da]);
          }

          onSuccess(data);
        }
      },
    });
  };

  return (
    <AttentionTip text={text || ''}>
      <Upload
        fileList={imgList}
        accept={'.png, .jpg, .jpeg'}
        maxCount={maxNum}
        listType={'picture-card'}
        onRemove={onDelete}
        customRequest={customRequest}
      >
        <UploadOutlined />
        点击上传
      </Upload>
    </AttentionTip>
  );
}
